import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Box } from "@mui/system";
import DateRangeIcon from "@mui/icons-material/DateRange";
import theme, { padding } from "../../../theme";
import {ArrowLeft, ArrowRight } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import { ClickOutsideWrapper } from "../ClickOutsideWrapper";
import { CustomDatePicker } from "./customDatePicker";
import { TagButton, TagButtons } from "./tagButtons";
import { useEffect, useState } from "react";
import { IconButton } from "@mui/material";

export const DatePickerPopUp = ({
  date,
  onDatePicked,
  setOpen,
  open,
  text,
  error,
  presets
}: {
  date: DateTime | undefined;
  onDatePicked: Function;
  setOpen: Function
  open: boolean,
  text?: string
  error?: boolean,
  presets?: TagButton[]
}) => {

  const isMobile = useSelector(
    (state: any) => state.dimensions.device === "mobile"
  );

  const [selected, setSelected] = useState<TagButton>();
    useEffect(() => {
      if (!selected)
        presets?.map((p) => {
          if (p.default === true) {
            setSelected(p)
          }
        })
    }, [presets, selected])

  const stepper = {day: 1}
  const step = "day"
  const today = DateTime.now();  

  return (
    <div style={{ marginBottom: padding * 2, marginTop: padding * 2 }}>
      <ClickOutsideWrapper onClickOutside={setOpen} >
        <Box
          sx={{
            height: 40,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            border: !error ? "1px #868686 solid" : `1px ${theme.palette.error.main} solid` ,
            paddingLeft: padding / 4,
            paddingRight: padding / 4,
            borderRadius: 1,
          }}
        >
          <Box
            onClick={() => setOpen(!open)}
            sx={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <DateRangeIcon sx={{ marginRight: padding / 2 }} />
              <p style={{ fontSize: isMobile ? 14 : 14, opacity: date ? 1 : 0.5}}>
                {text ? (date ? `${text} ${date.toFormat("dd LLL yyyy")}` : text) : (date ? date.toFormat("dd LLL yyyy") : "")}
              </p>

          </Box>
          <IconButton 
            onClick={() => {
              onDatePicked(date?.minus(stepper).startOf(step));
            }}
            disabled={!date}
            sx={{color: theme.palette.primary.main, padding: "0px"}}
            >
            <ArrowLeft/>
          </IconButton>
          <IconButton 
            onClick={() => {
              if (date && date.plus(stepper).startOf(step) <= today.startOf(step)) {
                onDatePicked(date?.plus(stepper).startOf(step));
              }
            }}
            disabled={!date || date.plus(stepper).startOf(step) > today.startOf(step)}
            sx={{color: theme.palette.primary.main, padding: "0px"}}
            >
            <ArrowRight/>
          </IconButton>
        </Box>

        {open && (
          <div
            style={{
              marginTop: padding,
              flexDirection: "column",
              display: "flex",
              boxShadow: "2px 2px 10px 0px #868686",
              position: "absolute",
              backgroundColor: "white",
              zIndex: 10,
              borderRadius: 2,
            }}
          >
            <Close
              sx={{
                borderRadius: 2,
                color: theme.palette.background.default,
                margin: padding / 8,
                flexDirection: "row",
                alignSelf: "end",
                "&:hover": {
                  cursor: "pointer",
                  bgcolor: theme.palette.background.default,
                  color: "white",
                },
              }}
              onClick={() => setOpen(false)}
            />
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                paddingRight: padding,
              }}
            >
              {
                presets && (
                  <TagButtons
                    direction={isMobile ? "row" : "column"}
                    tagButtons={presets}
                    selected={selected}
                    setSelected={setSelected}
                  />
                )
              }
              <CustomDatePicker
                  isMobile={isMobile}
                  setDate={(d) => {
                    onDatePicked(d)
                    setSelected({ name: "", id: "custom", action: () => console.log() })
                  }}
                  date={date}
                />
            </div>
          </div>
        )}
      </ClickOutsideWrapper>
    </div>
  );
};
